import { render, staticRenderFns } from "./WorkItemConfig.vue?vue&type=template&id=9c19d48e&scoped=true"
import script from "./WorkItemConfig.vue?vue&type=script&lang=js"
export * from "./WorkItemConfig.vue?vue&type=script&lang=js"
import style0 from "./WorkItemConfig.vue?vue&type=style&index=0&id=9c19d48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c19d48e",
  null
  
)

export default component.exports